import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/training/page';

export const Route = createFileRoute('/_app/settings/training/')({
  component: Page,
});
